import getTopics from '../topics/get-topics';

const getTopicsSections = state => {
  const topics = getTopics(state);
  return topics.reduce((prev, { sections }) => [...prev, ...sections], []);
};

export default getTopicsSections;
